import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BufferedInputComponent } from './buffered-input.component';


@NgModule({
  declarations: [BufferedInputComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
  ],
  exports: [BufferedInputComponent],
})
export class BufferedInputModule { }
